import './ActionLine.scss';

import { Alert, Confirm, CustomDialog, Prompt } from '../../Modal';
import React, { useState } from 'react';

import { Button } from '../Button/Button';
import DemoForm from '../Demo/DemoForm/DemoForm';
import { Link } from 'react-router-dom';

export function ActionLine(): JSX.Element {
    const [result, setResult] = useState<string>();

    return (
        <>
            <div className="actionLine">
                <div className="actionLine__buttons">
                    <Button
                        onClick={async () => {
                            await Alert('Alert Text', 'Alert Title');
                        }}
                    >
                        Alert
                    </Button>
                    <Button
                        onClick={async () => {
                            setResult(
                                String(await Confirm('Сonfirmation text', 'Сonfirmation Title'))
                            );
                        }}
                    >
                        Confirm
                    </Button>
                    <Button
                        onClick={async () => {
                            const age = await Prompt('How old are you?', {
                                isRequired: true,
                                defaultValue: 100,
                            });

                            if (age) {
                                Alert(`You are ${age} years old!`, 'Your age');
                            }

                            setResult(age);
                        }}
                    >
                        Prompt
                    </Button>
                    <Button
                        onClick={async () => {
                            setResult(
                                await CustomDialog(<DemoForm />, {
                                    title: 'Custom dialog',
                                })
                            );
                        }}
                    >
                        Custom
                    </Button>
                </div>
            </div>

            <div className="actionLineResult">
                {result !== undefined && (
                    <span>
                        Dialog result: <b>{result}</b>
                    </span>
                )}
            </div>

            <div className="getStartedBlock">
                <Link to="/started" className="startButton">
                    GETTING STARTED
                </Link>
            </div>
        </>
    );
}
